// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-FZBOy";
var _4 = "withTooltip-22ebs";
var _5 = "pay-1eOrM";
var _6 = "notAvailable-2BC_S";
var _7 = "paymentIcon-2Icw-";
var _8 = "optionIcon-2U2rw";
var _9 = "title-1bg6x";
var _a = "small-3ELLa";
var _b = "big-2qUAo";
var _c = "free-E8i4u";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "withTooltip", _5 as "pay", _6 as "notAvailable", _7 as "paymentIcon", _8 as "optionIcon", _9 as "title", _a as "small", _b as "big", _c as "free" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "withTooltip": _4, "pay": _5, "notAvailable": _6, "paymentIcon": _7, "optionIcon": _8, "title": _9, "small": _a, "big": _b, "free": _c }
